<script>
import Sidebar from "@/components/partials/SideBar.vue";
import Navbar from "@/components/partials/NavBar.vue";
export default {
    name: "BaseLayout",
    props: {
      bg: {
        type: String,
        default: `bg-gray-100`,
      },
    },
    components: {
        Sidebar,
        Navbar,
    }
}
</script>
<template>
    <div>
      <Navbar/>
      <div class="flex flex-row">
          <Sidebar/>
          <div :class="bg" class="main-content overflow-auto flex-1 bg-transparent mt-12 md:mt-10 pb-16 md:pb-5 px-1">
            <slot name="breadcrum"></slot>
            <slot name="content"></slot>
          </div>
      </div>
    </div>
</template>
